import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  type AuditStatusConfig,
  useDeleteAuditStatusConfig,
} from "@/hooks/use-audit-status-configs";

interface DeleteAuditStatusDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  config: AuditStatusConfig;
}

export function DeleteAuditStatusDialog({
  open,
  onOpenChange,
  config,
}: DeleteAuditStatusDialogProps) {
  const remove = useDeleteAuditStatusConfig();

  function handleDelete() {
    remove.mutate(config.id, {
      onSuccess: () => {
        onOpenChange(false);
      },
    });
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Delete Status</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete <span className="font-semibold">{config.label}</span>?
            This cannot be undone. Audits currently using this status must be updated first.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={remove.isPending}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDelete} disabled={remove.isPending}>
            {remove.isPending ? "Deleting..." : "Delete Status"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
